export var getAssetUrlsFromId = function getAssetUrlsFromId(manifest, id) {
  if (!manifest.assets[id]) {
    return;
  }

  return manifest.assets[id].map(function (asset) {
    return "".concat(manifest.publicPath).concat(asset);
  });
};